import React, { Component } from 'react';
import {  Row, Col} from 'react-bootstrap';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../css/style.css';
import '../components/Home';
import '../components/Home.css';
import { translate } from "react-i18next";
import AuthenticationService from '../backend/AuthenticationService';

class SimpleLayout extends Component {

  constructor(props) {
    super(props);
    this.onSelectTab = this.onSelectTab.bind(this);
   
    this.state = { 
      user: this.props.user,
      tabindex:0
     };
  }


 

  onSelectTab(tabindex){
    let oldState = this.state;
    console.log("tabIndex:"+tabindex);
   this.setState({
      ...oldState,
      tabindex: tabindex
    });
  }

 
    render(){
      const { t } = this.props;
      let user = AuthenticationService.getLoggedUser();
        return (
          <div id="container">
             <div id="header"><Header eventKey={this.props.eventKey} bg={this.props.bg} bgStrong={this.props.bgStrong}  /></div>
             <div id="body" >
             <Row className="justify-content-md-center">
              <Col xl={2} xs={6}  >
                <p>SimpleLayout left</p>
              </Col>
              <Col xl={8} xs={12} >
           


                {this.props.title ? 
                  <div>
                  <Row className="mt-2 mb-2">
                  <Col >
                      <h3 className="text-primary ml-2 mt-2 mb-2">{this.props.title}</h3>
                  </Col>
                   </Row>
                   <Row className="mt-2 ">
                  <Col >{this.props.children}</Col>
                  </Row>
                   </div>
                   : this.props.children
                }
                

             
              </Col>
              <Col xl={2} xs={6}  >
              <p>SimpleLayout right</p>
              </Col>
            </Row>
             </div>
             <div id="footer" ><Footer /></div>
          </div>
        );
    }

}


export default translate("translations")(SimpleLayout);